import useStringQueryParamState from "src/hooks/queryParamState/useStringQueryParamState";

const toolNames = [
  "data-explorer",
  "query-explorer",
  "version-history",
] as const;
export type ToolName = (typeof toolNames)[number];
export type SelectedToolName = ToolName | "none";

/*
 * The state for "no selected tool" is represented as ?sidebar=none.
 *
 * It cannot be represented as undefined, because when undefined we
 * default to showing the Data explorer.
 *
 * Define this as a variable to inform typescript that `selectedTool`
 * is a SelectedToolName and not just a string.
 */
const none: SelectedToolName = "none";

export function useToolbarState() {
  const [selectedTool, setSelectedTool, getToolUrl] =
    useStringQueryParamState<SelectedToolName>("sidebar", "data-explorer");

  if (isToolName(selectedTool)) {
    return { getToolUrl, setSelectedTool, selectedTool };
  } else {
    return { getToolUrl, setSelectedTool, selectedTool: none };
  }
}

function isToolName(selectedTool: string): selectedTool is ToolName {
  // @ts-ignore: array.includes(x) is ok even though x might not be in array
  return toolNames.includes(selectedTool);
}

export function useToolbarOptionState(tool: ToolName) {
  const { selectedTool, getToolUrl } = useToolbarState();
  const isSelected = selectedTool === tool;

  return {
    isSelected,
    toggledUrl: getToolUrl(isSelected ? none : tool),
  };
}
